/* Stockpile site behaviors: product page, collection filters, cart, early access, wedding party. */
(function () {
  if (window.__spSite) return; window.__spSite = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function money(c) { var n = c / 100; return "$" + n.toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || "null"); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function sess(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || "null"); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function fmtDate(d) { return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }); }
  function iso(d) { return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"); }

  /* Reveal on scroll */
  function reveal() {
    var els = $$("[data-reveal]:not(.in)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Need-by note shared by product page */
  function needByNote(input, out, days) {
    if (!input || !out) return;
    var t = new Date(); t.setHours(0, 0, 0, 0);
    input.min = iso(t);
    function upd() {
      if (!input.value) { out.innerHTML = ""; return; }
      var need = new Date(input.value + "T00:00:00"), d = Math.round((need - t) / 864e5);
      var by = new Date(need); by.setDate(by.getDate() - days - 2);
      if (d < 0) out.innerHTML = '<p class="sp-note">That date has passed. Pick the day you need to be dressed.</p>';
      else if (d <= days) out.innerHTML = '<p class="sp-note"><b>' + d + " day" + (d === 1 ? "" : "s") + " out.</b> Tight. Add it to your bag, then call the shop so the floor can hold your pieces today.</p>";
      else out.innerHTML = '<p class="sp-note ok"><b>On time.</b> Come in for your fitting by ' + fmtDate(by) + ", ready by " + fmtDate(need) + ".</p>";
    }
    input.addEventListener("change", upd); upd();
  }

  /* PRODUCT PAGE */
  function pdp() {
    var el = $("#sp-pdp"); if (!el) return;
    var data; try { data = JSON.parse($("#sp-pdata").textContent); } catch (e) { return; }
    var form = $("#sp-pform"), vid = $("[data-vid]", el), btn = $("[data-add-btn]", el), err = $("[data-err]", el);
    var days = +el.dataset.hemDays || 7, perMan = !!$(".per", el);
    var cur = data.variants.filter(function (v) { return String(v.id) === vid.value; })[0] || data.variants[0];
    var sel = cur.options.slice();

    function setVariant(v) {
      if (!v) return;
      cur = v; vid.value = v.id;
      $("[data-price]", el).textContent = money(v.price);
      var cmp = $("[data-compare]", el), sv = $("[data-save]", el);
      if (v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = money(v.compare_at_price) + " value"; sv.hidden = false; sv.textContent = "Save " + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%"; }
      else { cmp.hidden = true; sv.hidden = true; }
      btn.disabled = !v.available; btn.textContent = v.available ? "Add to bag" : "Sold out in this color";
      var sp = $("[data-sticky-price]", el); if (sp) sp.textContent = money(v.price) + (perMan ? " per man" : "");
      try { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u.toString()); } catch (e) {}
    }
    $$(".sp-swatches", el).forEach(function (group) {
      var oi = +group.dataset.opt;
      function mark() {
        $$("button", group).forEach(function (b) {
          b.setAttribute("aria-pressed", b.dataset.val === sel[oi] ? "true" : "false");
          var test = sel.slice(); test[oi] = b.dataset.val;
          var m = data.variants.filter(function (v) { return v.options.join("|") === test.join("|"); })[0];
          if (m && !m.available) b.setAttribute("data-oos", ""); else b.removeAttribute("data-oos");
        });
        var l = $('[data-optlabel="' + oi + '"]', el); if (l) l.textContent = sel[oi];
      }
      group.addEventListener("click", function (e) {
        var b = e.target.closest("button"); if (!b) return;
        sel[oi] = b.dataset.val; mark();
        setVariant(data.variants.filter(function (v) { return v.options.join("|") === sel.join("|"); })[0]);
      });
      mark();
    });

    $$("[data-q]", el).forEach(function (b) {
      b.addEventListener("click", function () { var i = b.parentNode.querySelector("input"); i.value = Math.max(1, Math.min(30, (+i.value || 1) + +b.dataset.q)); });
    });
    needByNote($("[data-needby]", el), $("[data-when]", el), days);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true; btn.textContent = "Adding…"; err.hidden = true;
      var fd = new FormData(form); Array.from(fd.keys()).forEach(function (k) { if (/^properties\[/.test(k) && !String(fd.get(k)).trim()) fd.delete(k); });
      fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || "Could not add to bag"); return j; }); })
        .then(function () { location.href = root + "cart"; })
        .catch(function (x) { err.textContent = x.message; err.hidden = false; btn.disabled = false; btn.textContent = "Add to bag"; });
    });

    /* gallery */
    var stage = $("#sp-stage");
    $$(".thumbs button", el).forEach(function (t) {
      t.addEventListener("click", function () {
        $$("figure", stage).forEach(function (f) { f.classList.toggle("on", f.dataset.i === t.dataset.go); });
        $$(".thumbs button", el).forEach(function (o) { o.setAttribute("aria-current", o === t ? "true" : "false"); });
      });
    });

    /* sticky bar */
    var sticky = $("#sp-sticky"), actions = $("#sp-actions");
    if (sticky && actions && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.classList.toggle("on", show); sticky.setAttribute("aria-hidden", show ? "false" : "true");
        $("[data-sticky-add]", sticky).tabIndex = show ? 0 : -1;
      }).observe(actions);
      $("[data-sticky-add]", sticky).addEventListener("click", function () { actions.scrollIntoView({ behavior: "smooth", block: "center" }); setTimeout(function () { btn.focus(); }, 500); });
    }
  }

  /* COLLECTION FILTERS */
  function coll() {
    var chips = $("#sp-chips"); if (!chips) return;
    var cards = $$("#sp-cards .sp-card"), none = $("#sp-nomatch");
    $$("button", chips).forEach(function (b) {
      var f = b.dataset.f; if (!f) return;
      if (!cards.some(function (c) { return c.dataset.tags.indexOf(" " + f + " ") > -1; })) b.hidden = true;
    });
    function apply(f) {
      var n = 0;
      cards.forEach(function (c) { var on = !f || c.dataset.tags.indexOf(" " + f + " ") > -1; c.hidden = !on; if (on) n++; });
      $$("button", chips).forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.f === f ? "true" : "false"); });
      if (none) none.hidden = n > 0;
      try { history.replaceState(null, "", f ? "#" + f : location.pathname + location.search); } catch (e) {}
    }
    chips.addEventListener("click", function (e) { var b = e.target.closest("button"); if (b) apply(b.dataset.f); });
    var r = $("[data-f-reset]"); if (r) r.addEventListener("click", function () { apply(""); });
    var h = location.hash.slice(1);
    if (h && $$("button", chips).some(function (b) { return b.dataset.f === h && !b.hidden; })) apply(h);
  }

  /* CART */
  function cart() {
    var el = $("#sp-cart"); if (!el) return;
    function change(line, qty) {
      el.classList.add("busy");
      fetch(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function () { location.reload(); }).catch(function () { location.reload(); });
    }
    $$(".sp-line", el).forEach(function (row) {
      var line = +row.dataset.line, input = $("input", row);
      $$("[data-cq]", row).forEach(function (b) { b.addEventListener("click", function () { change(line, Math.max(0, (+input.value || 0) + +b.dataset.cq)); }); });
      input.addEventListener("change", function () { change(line, Math.max(0, +input.value || 0)); });
      var rm = $("[data-rm]", row); if (rm) rm.addEventListener("click", function (e) { e.preventDefault(); change(line, 0); });
    });
    $$("[data-addon]", el).forEach(function (b) {
      b.addEventListener("click", function () {
        b.disabled = true; b.textContent = "Adding…";
        fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +b.dataset.addon, quantity: 1 }] }) })
          .then(function () { location.reload(); });
      });
    });
  }

  /* EARLY ACCESS POPUP */
  function ea() {
    var d = $("#sp-ea"); if (!d || typeof d.showModal !== "function") return;
    var KEY = "sp-ea-seen";
    function open() { if (!d.open) { try { d.showModal(); } catch (e) {} } }
    function close() { d.close(); store(KEY, Date.now()); }
    $("[data-ea-close]", d).addEventListener("click", close);
    d.addEventListener("click", function (e) { if (e.target === d) close(); });
    d.addEventListener("cancel", function () { store(KEY, Date.now()); });
    if (d.hasAttribute("data-open-now") || /customer_posted=true/.test(location.search)) { open(); store(KEY, Date.now()); return; }
    var seen = store(KEY);
    if (seen && Date.now() - seen < 14 * 864e5) return;
    var fired = false;
    function fire() { if (fired) return; fired = true; open(); }
    setTimeout(fire, (+d.dataset.delay || 12) * 1000);
    window.addEventListener("scroll", function onS() { if (window.scrollY > document.body.scrollHeight * 0.5) { window.removeEventListener("scroll", onS); fire(); } }, { passive: true });
  }

  /* WEDDING PARTY */
  var SUITS = { midnight: "Midnight navy", charcoal: "Charcoal", black: "Black" };
  var TIES = { champagne: "Champagne", dustyblue: "Dusty blue", sage: "Sage", burgundy: "Burgundy" };
  function partyCode(groom, date) {
    var g = (groom || "").replace(/[^a-z]/gi, "").toUpperCase().slice(0, 6);
    var dt = (date || "").replace(/-/g, "").slice(4) || "TBD";
    return g ? g + "-" + dt : "";
  }
  function party() {
    var el = $("#sp-party"); if (!el) return;
    var fr = el.dataset.fr || "/pages/fitting-room";
    var q = new URLSearchParams(location.search);
    var lookSel = $('[data-p="look"]', el);
    function lookName(id) { var o = lookSel && $$("option", lookSel).filter(function (x) { return x.value === id; })[0]; return o ? o.textContent.split(" · ")[0] : "The Groomsman"; }
    function enable(fs) { $$("[data-fs]", el).forEach(function (f) { f.disabled = f.dataset.fs !== fs; }); }
    function fillHidden(P) {
      var map = { code: P.code, groom: P.groom, date: P.date, lookname: lookName(P.look), suitname: P.look === "groomsman" ? SUITS[P.suit] : "", tiename: P.look === "groomsman" ? TIES[P.tie] : "", count: String(P.names.length || ""), names: P.names.join(", "), link: P.link };
      $$("[data-h]", el).forEach(function (h) { h.value = map[h.dataset.h] || ""; });
    }
    function linkFor(P) {
      var u = new URL(location.origin + location.pathname);
      u.searchParams.set("party", P.code); u.searchParams.set("g", P.groom); u.searchParams.set("d", P.date); u.searchParams.set("b", P.look);
      if (P.look === "groomsman") { u.searchParams.set("s", P.suit); u.searchParams.set("t", P.tie); }
      return u.toString();
    }
    function payLink(P) {
      var st = { b: P.look, s: {}, p: { count: 1, groom: P.groom, date: P.date } };
      if (P.look === "groomsman") st.s = { suit: P.suit, tie: P.tie };
      if (P.date) st.d = P.date;
      try { return fr + "#look=" + btoa(unescape(encodeURIComponent(JSON.stringify(st)))); } catch (e) { return fr + "#" + P.look; }
    }
    function meta(P) {
      var dl = $("[data-partymeta]", el); if (!dl) return;
      var date = P.date ? new Date(P.date + "T00:00:00").toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" }) : "Date to be set";
      var rows = [["Party", P.code], ["Date", date], ["Look", lookName(P.look)]];
      if (P.look === "groomsman") rows.push(["Suit", SUITS[P.suit] + ", " + TIES[P.tie] + " tie and square"]);
      dl.innerHTML = rows.map(function (r) { return "<dt>" + r[0] + "</dt><dd>" + String(r[1]).replace(/[<>&]/g, "") + "</dd>"; }).join("");
      dl.hidden = false;
    }
    function roster(P) {
      var ul = $("[data-roster]", el), key = "sp-party-" + P.code, st = store(key) || {};
      ul.innerHTML = (P.names.length ? P.names : ["Groomsman 1", "Groomsman 2", "Groomsman 3"]).map(function (n, i) {
        var s = st[n] || {};
        return '<li><span>' + n.replace(/[<>&]/g, "") + '</span><label><input type="checkbox" data-r="' + i + '" data-k="size"' + (s.size ? " checked" : "") + '> Size sent</label><label><input type="checkbox" data-r="' + i + '" data-k="paid"' + (s.paid ? " checked" : "") + "> Paid</label></li>";
      }).join("");
      ul.onchange = function (e) {
        var c = e.target; if (!c.dataset.k) return;
        var n = $$("li span", ul)[+c.dataset.r].textContent; st[n] = st[n] || {}; st[n][c.dataset.k] = c.checked; store(key, st);
      };
    }
    function showShare(P) {
      $("[data-code]", el).textContent = P.code;
      $("[data-link]", el).value = P.link;
      var msg = "You're in the " + P.groom + " wedding. Open this, check the look, and send your size to Stockpile: " + P.link;
      $("[data-sms]", el).href = "sms:?&body=" + encodeURIComponent(msg);
      var sh = $("[data-share]", el);
      if (navigator.share) { sh.hidden = false; sh.onclick = function () { navigator.share({ title: "Party " + P.code, text: msg, url: P.link }).catch(function () {}); }; }
      roster(P); fillHidden(P); meta(P);
      $('[data-pane="groom"]', el).hidden = true; $('[data-pane="share"]', el).hidden = false; enable("groom");
    }
    $("[data-copy]", el).addEventListener("click", function () {
      var i = $("[data-link]", el); i.select();
      (navigator.clipboard ? navigator.clipboard.writeText(i.value) : Promise.reject()).then(function () { $("[data-copy]", el).textContent = "Copied"; }, function () { try { document.execCommand("copy"); $("[data-copy]", el).textContent = "Copied"; } catch (e) {} });
    });
    $("[data-edit]", el).addEventListener("click", function () { $('[data-pane="share"]', el).hidden = true; $('[data-pane="groom"]', el).hidden = false; enable(""); });
    function gmToggle() { var gm = lookSel && lookSel.value === "groomsman"; $$("[data-gm-only]", el).forEach(function (x) { x.hidden = !gm; }); }
    if (lookSel) { lookSel.addEventListener("change", gmToggle); gmToggle(); }

    $("[data-create]", el).addEventListener("click", function () {
      var g = $('[data-p="groom"]', el).value.trim(), d = $('[data-p="date"]', el).value, e = $("[data-setup-err]", el);
      if (!g || !d) { e.textContent = "Add the groom's last name and the wedding date."; e.hidden = false; return; }
      e.hidden = true;
      var P = { groom: g, date: d, look: lookSel ? lookSel.value : "groomsman", suit: $('[data-p="suit"]', el).value, tie: $('[data-p="tie"]', el).value,
        names: $('[data-p="names"]', el).value.split("\n").map(function (x) { return x.trim(); }).filter(Boolean) };
      P.code = partyCode(g, d); P.link = linkFor(P);
      store("sp-party-last", P); showShare(P);
      $('[data-pane="share"]', el).scrollIntoView({ behavior: "smooth", block: "start" });
    });

    /* who is here */
    var form = $("#sp-partyform");
    var posted = !!$("[data-posted]", el), last = sess("sp-party-post");
    if (posted && last) {
      $$("[data-pane]", el).forEach(function (p) { p.hidden = p.dataset.pane !== "done"; });
      meta(last.P);
      if (last.mode === "man") {
        $("[data-done-msg]", el).innerHTML = "<b>Sent.</b> Stockpile has your size under party " + last.P.code + ". It's confirmed with a tape at the fitting.";
        $("[data-pay]", el).href = payLink(last.P);
        $("[data-tellgroom]", el).href = "sms:?&body=" + encodeURIComponent("I sent my size to Stockpile for party " + last.P.code + ".");
      } else {
        $("[data-done-msg]", el).innerHTML = "<b>Registered.</b> Stockpile has party " + last.P.code + ". Keep sending the link to the rest of the party.";
        $("[data-pay]", el).href = payLink(last.P); $("[data-pay]", el).textContent = "Pay for the party now";
        $("[data-tellgroom]", el).hidden = true;
        var again = document.createElement("a"); again.className = "btn"; again.href = last.P.link; again.textContent = "Back to the party link";
        $("[data-done-btns]", el).appendChild(again);
      }
      return;
    }
    if (q.get("party")) {
      var P = { code: q.get("party"), groom: q.get("g") || "", date: q.get("d") || "", look: q.get("b") || "groomsman", suit: q.get("s") || "midnight", tie: q.get("t") || "champagne", names: [] };
      if (!SUITS[P.suit]) P.suit = "midnight"; if (!TIES[P.tie]) P.tie = "champagne";
      P.link = location.href;
      $("[data-mode-eyebrow]", el).textContent = "Weddings · Groomsman";
      $("[data-mode-title]", el).textContent = "The " + P.groom.replace(/[<>&]/g, "") + " wedding.";
      $("[data-mode-lead]", el).textContent = "You're in. Check the look below, then send your size. Stockpile confirms it with a tape at the group fitting.";
      meta(P); fillHidden(P);
      $$("[data-pane]", el).forEach(function (p) { p.hidden = p.dataset.pane !== "man"; });
      enable("man");
      form.addEventListener("submit", function () { sess("sp-party-post", { mode: "man", P: P }); });
      return;
    }
    var prev = store("sp-party-last");
    if (prev && prev.code) {
      $('[data-p="groom"]', el).value = prev.groom; $('[data-p="date"]', el).value = prev.date;
      if (lookSel) lookSel.value = prev.look; $('[data-p="suit"]', el).value = prev.suit; $('[data-p="tie"]', el).value = prev.tie;
      $('[data-p="names"]', el).value = (prev.names || []).join("\n"); gmToggle();
      showShare(prev);
    }
    form.addEventListener("submit", function () { var p = store("sp-party-last"); if (p) sess("sp-party-post", { mode: "groom", P: p }); });
  }

  function init() { pdp(); coll(); cart(); ea(); party(); reveal(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function () { reveal(); });
})();
